import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    submit(event) {
        if (this.bypassRecaptcha) return

        event.preventDefault()
        if (!this.element.reportValidity()) return

        if (typeof grecaptcha === 'undefined') {
            console.error("grecaptcha not loaded")
            this.safeSubmit()
            return
        }

        const key = document.querySelector('meta[name="recaptcha-site-key"]').content;

        grecaptcha.execute(key, { action: 'submit' })
            .then((token) => {
                let input = this.element.querySelector('input[name="recaptcha_token"]')
                if (!input) {
                    input = document.createElement('input')
                    input.type = 'hidden'
                    input.name = 'recaptcha_token'
                    this.element.appendChild(input)
                }
                input.value = token

                this.safeSubmit()
            })
            .catch((error) => {
                console.error("reCAPTCHA error:", error)
                this.safeSubmit()
            })
    }
    safeSubmit() {
        const csrfMeta = document.querySelector('meta[name="csrf-token"]')
        const csrfInput = this.element.querySelector('input[name="authenticity_token"]')

        if (csrfMeta && csrfInput) {
            csrfInput.value = csrfMeta.content
        }

        this.bypassRecaptcha = true
        this.element.requestSubmit()
        this.bypassRecaptcha = false
    }
}
